module.exports = __webpack_public_path__ + "media/images/logos/javascript-85c25368fd3d4894512e2b9df3d7656e.svg";